import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { WizVgroup } from '@wizeoo/akm-component-lib';
import { VisionStep, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { VisionVO } from '@wizeoo/akm-compute-lib';

import { WIDGET_ACTION_ORIGIN, WIDGET_GLOBAL_KIND, WIDGET_KIND } from '../../../model/enums';
import { ViewData } from '../../../model/view.data';
import { FreedataWidgetBasic } from '../base/freedata-widget-basic';
import { GridsterWidgetItem } from '../../../vo/workingzone/gridster-widget-item';
import { PivotField } from '../../../manager/baselines/pivot-field.obj';
import { FreeFormSettingsPop } from './pop/freeform-settings.pop';

@Component({
  selector: 'free-form-widget',
  templateUrl: './free-form.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** formulaire libre */
export class FreeFormWidget extends FreedataWidgetBasic implements AfterViewInit, OnDestroy {
  /* ##############################################################################
                  composants spécifiques
  ############################################################################## */

  // zone d'ajout des champs de saisie
  @ViewChild('fieldsContainer', { read: ViewContainerRef, static: true }) fieldsContainer: ViewContainerRef;
  @ViewChild('argsZone', { read: WizVgroup }) argsZone: WizVgroup; // zone d'édition des args

  widgets: GridsterWidgetItem[]; // item de travail


  /* ##############################################################################
                  paramètres spécifiques
  ############################################################################## */

  /** visibilité des bts save / cancel */
  public get editMode(): boolean  {
    return false;
  }

  /**
   * mode création
   */
  public get creationMode(): boolean  {
    return true; // TODO détecter l'ouverture en popUp
  }


  constructor(elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super(elementRef);
    this.widgetKind = WIDGET_KIND.FREE_FORM;
    this.widgetGlobalKind = WIDGET_GLOBAL_KIND.NONE;
    this.settingsPopClassFactory = FreeFormSettingsPop;
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  /**
   * actions jouées sur le drawContent, le alterContent, ou en cas de modifs de filtre, de sélection
   * @override
   * @param origin WIDGET_ACTION_ORIGIN pour cibler qui demande
   * @param data l'objet éventuellement porté
   */
  public drawOrRefresh(origin: WIDGET_ACTION_ORIGIN, data?: any): void {

    if(origin === WIDGET_ACTION_ORIGIN.READY) { // je me suis dit tout seul que j'étais prêt
      this.feed();
    }

    if(origin === WIDGET_ACTION_ORIGIN.CONFIGURE) {  
      this.feed();
    } 
  }

  /**
   * construction 'initiale' des objets graphiques du widget :
   * - sur init véritable
   * - sur modification de la datasource
   * - sur modification de scenario (modifie la DS)
   */
  public drawContent(): void {
    this.drawOrRefresh(WIDGET_ACTION_ORIGIN.INIT); // actions communes draw / alter
    super.drawContent(); // pas au début, c'est lui qui dispatch les events
  }

  /**
   * reconstruction des objets graphiques du widget sur changement de structure : 
   * - changement de structure
   * @param origin 
   */
  public alterContent(origin: WIDGET_ACTION_ORIGIN): void {
    this.drawOrRefresh(origin);
    super.alterContent(origin);
  }

  /**
   * @override IWidget : méthode d'alimentation des données du composant
   * tout est à null, on continue quand même
   */
  public setDatasource(v: VisionVO, vs: VisionStep, scenario: string): void {
    this.drawContent();
  }

  /** 
   * construction des champs de saisie
   */
  public feed() {
    this.widgets = [];
    if (this.context.ff) {
      this.context.ff.forEach((obj: WidgetConfigurationItemObj) => {

        if(ViewData.isFreeField(obj.fdvf) ) {
          const result: GridsterWidgetItem = new GridsterWidgetItem(obj, new PivotField(this, obj, null, null)); 
          this.widgets.push(result);
        } else {
        }
      });      
    }

    this.cdref.markForCheck();
  }

}

